<template>
  <crud-container :class="{'page-compact':crud.pageOptions.compact}">
    <b-modal id="poolWarning" title="LANTERN warning" hide-header-close ok-only>{{ poolWarningText }}</b-modal>
    <b-modal id="poolMessage" title="LANTERN message" hide-header-close ok-only>{{ poolMessageText }}</b-modal>
    <b-modal id="poolResult" hide-footer scrollable size="xl" :trim="true" title="LANTERN interpreter" readonly class='h-60'>
      <textarea v-model="translationResult" class="form-control"></textarea>
    </b-modal>
    <b-modal hide-footer scrollable size="xl" v-model="poemShow" :trim="true" title="Query Result">
      <d2-crud-x :columns="columns" :data="data" :options="options" />
    </b-modal>
    <b-modal id="poolPanel" size="lg" title="Configuring via statements" hide-header-close @ok="submitPool" @cancel="clearPoolPanel">
      <textarea v-model="poolStatement" class="form-control" placeholder="Please input POOL statements here..."></textarea>
    </b-modal>
    <template slot="header">
      POEM for various DBMS
      <example-helper title="Help">
        <h4>Provide help documentation here</h4>
      </example-helper>
    </template>
    <d2-crud-x ref="d2Crud" v-bind="_crudProps" v-on="_crudListeners">
      <div slot="header">
        <crud-search ref="search" :options="crud.searchOptions" @submit="handleSearch" :text="query_text" />
        <el-button size="small" type="primary" @click="addRow">
          <i class="el-icon-plus" /> Add
        </el-button>
        <el-button slot="suffix" size="small" type="success" v-on:click="showPool()">
          <i class="el-icon-plus" /> operate with statement
        </el-button>
        <crud-toolbar
          :search.sync="crud.searchOptions.show"
          :compact.sync="crud.pageOptions.compact"
          :columns="crud.columns"
          :text="toolbar_text"
          @refresh="doRefresh()"
          @columns-filter-changed="handleColumnsFilterChanged"
        />
      </div>
      <template slot="aliasFormSlot" slot-scope="scope">
        <el-input :disabled="scope.mode==='view'" class="d2-mb-5" v-model="scope.form.alias">
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-circle-plus-outline" />
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-remove-outline" />
        </el-input>
        <!-- <el-button :disabled="scope.mode==='view'" @click="addTopic">add</el-button> -->
      </template>
      <template slot="descriptionFormSlot" slot-scope="scope">
        <el-input :disabled="scope.mode==='view'" class="d2-mb-5" v-model="scope.form.description">
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-circle-plus-outline" />
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-remove-outline" />
        </el-input>
        <!-- <el-button :disabled="scope.mode==='view'" @click="addTopic">add</el-button> -->
      </template>
      <template slot="targetFormSlot" slot-scope="scope">
        <el-input :disabled="scope.mode==='view'" class="d2-mb-5" v-model="scope.form.target">
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-circle-plus-outline" />
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-remove-outline" />
        </el-input>
        <!-- <el-button :disabled="scope.mode==='view'" @click="addTopic">add</el-button> -->
      </template>
      <!--TODO: provide add desc or other columns function for user -->
      <!-- <template slot="testFormSlot" slot-scope="scope">
        <el-input
          :disabled="scope.mode==='view'"
          class="d2-mb-5"
          v-for="(item,index) in scope.form.test"
          :key="index"
          v-model="scope.form.test[index]"
        >
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-remove-outline" @click="removeTopic(index)" />
          <el-button :disabled="scope.mode==='view'" slot="append" icon="el-icon-remove-outline" @click="removeTopic(index)" />
        </el-input>
        <el-button :disabled="scope.mode==='view'" @click="addTopic">add</el-button>
      </template>-->
    </d2-crud-x>
  </crud-container>
</template>


<script>
import { crudOptions } from './crud'
import { d2CrudPlus } from 'd2-crud-plus'
import { GetList, AddObj, UpdateObj, DelObj, configurePoem } from '@/api.js'
export default {
  name: 'AddPOEM',
  data: function () {
    return {
      poolStatement: '',
      poolWarningText: '',
      poemShow: false,
      data: [],
      columns: [],
      poolMessageText: '',
      translationResult: '',
      options: {
        height: '100%',
        maxHeight: 300,
        stripe: true,
        emptyText: 'No data',
        border: true
      },
      query_text: { search: 'search', reset: 'reset' },
      toolbar_text: {
        refreshBtn: 'refresh',
        searchBtn: 'show/hide search',
        compactBtn: 'compact page',
        exportBtn: 'export',
        columnsSetBtn: 'column settings',
        columnsSet: { title: 'Column settings', fixed: 'Fixed', order: 'Sort', reset: 'Reset', confirm: 'Confirm', unnamed: 'Unnamed' }
      }
    }
  },
  mixins: [d2CrudPlus.crud],
  methods: {
    async getCrudOptions() {
      return crudOptions
    },
    async pageRequest(query) {
      let response = await GetList(query)
      return response
    },
    async addRequest(row) {
      return AddObj(row)
    },
    async updateRequest(row) {
      let response = await UpdateObj(row)
      return response
    },
    async delRequest(row) {
      return DelObj(row.id)
    },
    // Built-in call, rewrite text configuration
    handleRowRemove({ index, row }, done) {
      this.delRequest(row)
      setTimeout(() => {
        // console.log(index)
        // console.log(row)

        this.$message({
          message: 'Successfully deleted',
          type: 'success'
        })
        done()
      }, 300)
    },
    handleRowEdit({ index, row }, done) {
      crudOptions.formOptions.saveLoading = true
      this.updateRequest(row)
      setTimeout(() => {
        // console.log(index)
        // console.log(row)
        this.$message({
          message: 'Edit successfully',
          type: 'success'
        })
        done()
        crudOptions.formOptions.saveLoading = false
      }, 300)
    },
    handleRowAdd(row, done) {
      crudOptions.formOptions.saveLoading = true
      this.addRequest(row)
      setTimeout(() => {
        // console.log(row)
        this.$message({
          message: 'Saved successfully',
          type: 'success'
        })
        done()
        crudOptions.formOptions.saveLoading = false
      }, 300)
    },
    showPool() {
      this.$bvModal.show('poolPanel')
    },
    async submitPool() {
      if (this.poolStatement !== '') {
        let response = await configurePoem(this.poolStatement)
        console.log(response.data['msg'])
        if (response.data['code'] === 'f') {
          this.poolWarningText = response.data['msg']
          this.$bvModal.show('poolWarning')
        } else if (response.data['type'] === 'select') {
          this.columns = JSON.parse(response.data['col_info'])
          this.data = JSON.parse(response.data['row_info'])
          this.poemShow = true
        } else if (response.data['type'] === 'test') {
          this.translationResult = response.data['msg']
          this.$bvModal.show('poolResult')
        } 
        else {
          this.poolMessageText = response.data['msg']
          this.$bvModal.show('poolMessage')
        }
      } else {
        this.poolWarningText = 'Please input your POOL before submitting'
        this.$bvModal.show('poolWarning')
      }
      this.$bvModal.hide('poolPanel')
      this.clearPoolPanel()
    },
    clearPoolPanel() {
      this.poolStatement = ''
    }
  }
}
</script>

<style>
.h-70 {
  height: 70%;
}
</style>